import { Container } from 'reactstrap';
import { NavMenu } from './NavMenu';
import './Layout.css';
import './font.css';
import PropTypes from 'prop-types';
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { Disclaimer } from '../common/Disclaimer';
import { UswdsIdentifier } from './UswdsIdentifier';
import { UswdsHeader } from './UswdsHeader';

library.add(fas)

export function Layout({ children }) {
  return (
    <div>
      <UswdsHeader />
      <NavMenu />
      <div className="container-fluid">
        <Container>
          {children}
          <Disclaimer />
        </Container>
      </div>
      <UswdsIdentifier />
    </div>
  );
}

Layout.propTypes = {
  children: PropTypes.array.isRequired,
}
